var path = '/modules/documents/views/main/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documents/views/main/list.tpl.html
// module id = 2093
// module chunks = 1